import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Image,
  Input,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { Icon, Img } from "../../../../content/Content";
import { FaMagnifyingGlass } from "react-icons/fa6";
import '../Chat.component.css'
const ChatApplication = () => {
  return (
    <VStack bg="#FFFFFF" w="100%" borderRadius="18px" mx="10px" p="20px 30px" h="939px" justifyContent="space-between">
      {/*  top bar */}
      <Stack
        flexDir="row"
        w="100%"
        py="15px"
        alignItems="center"
      >
        <Box
          w="80%"
          display="flex"
          flexDir="row"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Box
            w="49px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            h="49px"
            borderRadius="50px"
            bg={"#92E0CD"}
            color={"#21997C "}
          >
            FRX
          </Box>
          {/* <Image src={Img.avatar1} h="47px" w="47px" /> */}
          <Box mx="20px">
            <Text
              fontFamily="'Roboto',sans-serif"
              fontSize="20px"
              fontWeight="500"
              color="#9597AB"
            >
              Forex Agency
            </Text>
            <Text
              display="flex"
              flexDir="row"
              fontFamily="'Roboto',sans-serif"
              fontSize="16px"
              fontWeight="400"
              pt="5px"
              color="#9597AB"
            >
              Des 12 2023
              <Text mx="10px">10:00 AM</Text>
            </Text>
          </Box>
        </Box>
        <Box
          w="20%"
          display="flex"
          flexDir="column"
          justifyContent="space-between"
          alignItems="flex-end"
        >
          <Box>
            <FormControl
              position="relative"
              color="#9597AB"
              display="flex"
              alignItems="center"
            >
              <FaMagnifyingGlass style={{ marginRight: "0" }} />
              <Input
                type="text"
                placeholder="Search"
                color="#9597AB"
                border="0"
              />
            </FormControl>
          </Box>
        </Box>
      </Stack>
      <Box w="100%" borderTop="1px solid rgba(149, 151, 171, 1)" opacity="0.1" mt="-20px">
      </Box>
      {/* chat1 */}
      <VStack>
        <Stack
          flexDir="row"
          justifyContent="start"
          w="100%"
          py="10px"
          alignItems="center"
        >
          <Image src={Img.chat1} w="37px" h="37px" />
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="20px"
            fontWeight="500"
            color="#000000"
          >
            Cameron
          </Text>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#9597AB"
          >
            Yesterday 10:00:30 AM
          </Text>
        </Stack>
        {/* message */}
        <Stack
          bg="#F5F5FF"
          w="80%"
          ms="10px"
          borderRadius="0px 10px 10px 10px"
          p="20px"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#000000"
          >
            Twenty 30-second applications within half an hour is well in excess
            of almost anyone’s use of a sani
          </Text>
        </Stack>
      </VStack>

      {/* chat2 */}
      <VStack>
        <Stack
          flexDir="row"
          justifyContent="flex-end"
          w="100%"
          py="10px"
          alignItems="center"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#9597AB"
          >
            Yesterday 10:00:30 AM
          </Text>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="20px"
            fontWeight="500"
            color="#000000"
          >
            Cameron
          </Text>
          <Image src={Img.chat1} w="37px" h="37px" />
        </Stack>
        {/* message */}
        <Stack
          bg="#601FEB"
          w="80%"
          ms="10px"
          borderRadius="10px 0px 10px 10px"
          p="20px"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#fff"
          >
            Twenty 30-second applications within half an hour is well in excess
            of almost anyone’s use of a sani
          </Text>
        </Stack>
      </VStack>

      {/* chat3 */}
      <VStack>
        <Stack
          flexDir="row"
          justifyContent="start"
          w="100%"
          py="10px"
          alignItems="center"
        >
          <Image src={Img.chat1} w="37px" h="37px" />
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="20px"
            fontWeight="500"
            color="#000000"
          >
            Cameron
          </Text>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#9597AB"
          >
            Yesterday 10:00:30 AM
          </Text>
        </Stack>
        {/* message */}
        <Stack
          bg="#F5F5FF"
          w="80%"
          ms="10px"
          borderRadius="0px 10px 10px 10px"
          p="20px"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#000000"
          >
            Twenty 30-second applications within half an hour is well in excess
            of almost anyone’s use of a sani
          </Text>
        </Stack>
      </VStack>

      {/* chat4 */}
      <VStack>
        <Stack
          flexDir="row"
          justifyContent="flex-end"
          w="100%"
          py="10px"
          alignItems="center"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#9597AB"
          >
            Yesterday 10:00:30 AM
          </Text>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="20px"
            fontWeight="500"
            color="#000000"
          >
            Cameron
          </Text>
          <Image src={Img.chat1} w="37px" h="37px" />
        </Stack>
        {/* message */}
        <Stack
          bg="#601FEB"
          w="80%"
          ms="10px"
          borderRadius="10px 0px 10px 10px"
          p="20px"
        >
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="16px"
            fontWeight="400"
            color="#fff"
          >
            Twenty 30-second applications within half an hour is well in excess
            of almost anyone’s use of a sani
          </Text>
        </Stack>
      </VStack>

      {/* bottom bar */}

      <VStack bg="#F5F5FF" h="50px" borderRadius="11px" w="100%" mt="15px" alignItems="center" flexDir="row">
            <Box w="50%">
                <FormControl>
                    <Input type="text" placeholder="Type of message here "               fontFamily="'Roboto',sans-serif"
                    fontSize="16px"
                    fontWeight="400"
                    color="#9597AB"
                    h="19px"
                    bg="transparent"
                    border="none"
                    _focusVisible={{bg:"transparent",border:"0",outline:"0"}}
                    w="75%"
                />
                </FormControl>
            </Box>

            <Box w="50%" display="flex" alignItems="center" justifyContent='flex-end'>
                <Button p="0" bg="transparent" _hover={{bg:'transparent'}}>
                    <Image src={Icon.camera} w="22.73px" h="20px"/>
                </Button>
                <FormControl  mb="0"pb="0" mx="5px" w="20px">
                    <FormLabel mb="0"pb="0" w="37px">
                        <Image src={Icon.image}/>
                        <Input type="file" display="none"  />
                    </FormLabel>
                </FormControl>

                <Button w="30px" p="0" bg="transparent" _hover={{bg:'transparent'}}>
                    <Image src={Icon.voice} w="22.73px" h="20px"/>
                </Button>
                <Button w="30px" p="0" bg="transparent" _hover={{bg:'transparent'}}>
                    <Image src={Icon.emoji} w="22.73px" h="20px"/>
                </Button>

                <Button  p="0" bg="transparent" _hover={{bg:'transparent'}}>
                    <Text color="#9597AB" fontSize='17px'>Aa</Text>
                </Button>
                <Button p="0"  bg="transparent" _hover={{bg:'transparent'}}>
                    <Image src={Icon.Like}/>
                </Button>
                <Button p="0" borderRadius="7px" me="10px" bg="#601FEB" h="41px" w="41px" _hover={{bg:'transparent'}}>
                    <Image src={Icon.exportChat} h="20px" w="19.99px"/>
                </Button>
            </Box>
      </VStack>
    </VStack>
  );
};

export default ChatApplication;
